import { render, staticRenderFns } from "./SpeakerCertificate.vue?vue&type=template&id=ab41c70c&scoped=true&"
import script from "./SpeakerCertificate.vue?vue&type=script&lang=js&"
export * from "./SpeakerCertificate.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerCertificate.vue?vue&type=style&index=0&id=ab41c70c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab41c70c",
  null
  
)

export default component.exports